import { Directive, ElementRef, effect, inject, input } from '@angular/core';

@Directive({
  standalone: true,
  selector: '[abxChartTitle]',
})
export class ChartTitleDirective {
  readonly abxChartTitle = input<string>('');

  private readonly el = inject(ElementRef<SVGElement | HTMLElement>);

  constructor() {
    effect(() => {
      const title = this.abxChartTitle();
      const nativeEl = this.el.nativeElement;
      nativeEl.setAttribute('role', 'img');
      nativeEl.setAttribute('aria-label', title);

      // Only inject an SVG <title> when the host is an SVG element — an HTML
      // <title> inside a non-SVG element has no a11y semantics and is misleading.
      if (nativeEl instanceof SVGElement) {
        // Force the generic `querySelector<E>` overload: the bare `'title'` string
        // literal otherwise resolves to the HTMLElementTagNameMap overload
        // (HTMLTitleElement), which TS refuses to cast to SVGTitleElement (TS2352).
        let titleEl = nativeEl.querySelector<SVGTitleElement>('title');
        if (!titleEl) {
          titleEl = document.createElementNS('http://www.w3.org/2000/svg', 'title') as SVGTitleElement;
          nativeEl.prepend(titleEl);
        }
        titleEl.textContent = title;
      }
    });
  }
}
